import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ShapesIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ShapesIcon = ({ className, ...props }: ShapesIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.6 8.8a3.2 3.2 0 0 0 3.2-3.2c0-.582 0-.873.02-.96.086-.39.205-.511.595-.604.086-.02.254-.023.592-.027C10.606 4 11.267 4 12 4c1.097 0 2.035 0 2.842.029.326.012.49.017.587.047.339.101.456.223.545.564.026.1.026.386.026.96a3.2 3.2 0 0 0 3.2 3.2c.395 0 .77.275.78.669.02.734.02 1.572.02 2.531 0 .733 0 1.394-.009 1.993-.004.338-.007.506-.027.592-.093.39-.213.509-.605.596-.086.019-.377.019-.959.019a3.2 3.2 0 0 0-3.2 3.2c0 .582 0 .873-.02.96-.086.39-.205.511-.595.604-.086.02-.254.023-.592.027C13.394 20 12.733 20 12 20s-1.394 0-1.993-.009c-.338-.004-.506-.007-.592-.027-.39-.093-.509-.213-.596-.605-.019-.086-.019-.377-.019-.959a3.2 3.2 0 0 0-3.2-3.2c-.582 0-.873 0-.96-.02-.39-.086-.511-.205-.604-.595-.02-.086-.023-.254-.027-.592C4 13.394 4 12.733 4 12s0-1.394.009-1.993c.004-.338.007-.506.027-.592.093-.39.213-.509.605-.596.086-.019.377-.019.959-.019Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
  
export default ShapesIcon;